import React from 'react';

const SearchFilter = () => {
  return (
    <>
      <div className="search-filter">
        <div className="filter">
          <input type="radio" name='filter' className='filter-radio' defaultChecked/>
          <div className='filter-label'>All results</div>
        </div>
        <div className="filter">
          <input type="radio" name='filter' className='filter-radio'/>
          <div className='filter-label'>Videos (4)</div>
        </div>
        <div className="filter">
          <input type="radio" name='filter' className='filter-radio'/>
          <div className='filter-label'>Podcasts (3)</div>
        </div>
        <div className="filter">
          <input type="radio" name='filter' className='filter-radio'/>
          <div className='filter-label'>Stories (2)</div>
        </div>
      </div>
    </>
  );
};

export default SearchFilter;